import { render, staticRenderFns } from "./ViewDuties.vue?vue&type=template&id=06173f60"
import script from "./ViewDuties.vue?vue&type=script&lang=js"
export * from "./ViewDuties.vue?vue&type=script&lang=js"
import style0 from "./ViewDuties.vue?vue&type=style&index=0&id=06173f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports